const INIT_STATE = {
  loading: false,
  error: false,
  errorMessage: null,
	list: [],
	item: null,
	action: null,
	invalid: false
};

const reducer = (state = INIT_STATE, action) => {
	switch (action.type) {
		case 'INVALIDATE_COMPARES':
      return { ...state, invalid: true };

		case 'GET_COMPARES':
			return { ...state, loading: true, error: false, errorMessage: null, action: null, list: [], invalid: false };

		case 'GET_COMPARES_SUCCESS':
			return { ...state, loading: false, error: false, errorMessage: null, list: action.payload.data, action: null };

		case 'GET_COMPARES_FAILED':
			return { ...state, loading: false, error: true, errorMessage: action.payload.message, action: null };

		case 'GET_COMPARE':
			return { ...state, loading: true, error: false, action: null, item: null };

		case 'GET_COMPARE_SUCCESS':
			return { ...state, loading: false, error: false, item: action.payload.data, action: null };

		case 'GET_COMPARE_FAILED':
			return { ...state, loading: false, error: true, errorMessage: action.payload.message, action: null };

		case 'CREATE_COMPARE':
			return { ...state, loading: true, error: false, action: null }

		case 'CREATE_COMPARE_SUCCESS':
			return { ...state, loading: false, error: false, action: 'CREATED', item: action.payload.data }

		case 'CREATE_COMPARE_FAILED':
			return { ...state, loading: false, error: true, errorMessage: action.payload.message, action: null }

		case 'UPDATE_COMPARE':
			return { ...state, loading: true, error: false, action: null }

		case 'UPDATE_COMPARE_SUCCESS':
			return { ...state, loading: false, error: false, action: 'UPDATED', item: action.payload.data }

		case 'UPDATE_COMPARE_FAILED':
			return { ...state, loading: false, error: true, errorMessage: action.payload.message, action: null }

		case 'DELETE_COMPARE':
			return { ...state, loading: true, action: null }

		case 'DELETE_COMPARE_SUCCESS':
			return { ...state, loading: false, error: false, action: 'DELETED' }

		case 'DELETE_COMPARE_FAILED':
			return { ...state, loading: false, error: true, errorMessage: action.payload.message, action: null }

		default:
			return state;

	}
};

export default reducer;